import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";

/**
 * Props for SkeletonNoteView component
 */
interface Props {
  bgColor: string;
  itemBgColor: string;
}

/**
 * Pure view component for note skeleton
 * @param root0 - Component props
 * @param root0.bgColor - Background color value
 * @param root0.itemBgColor - Item background color value
 */
const SkeletonNoteView = ({ bgColor, itemBgColor }: Props) => (
  <Box className={`gap-2 rounded-sm px-5 py-3 ${itemBgColor}`}>
    <SkeletonPlaceholder>
      <Box>
        <Box className="gap-1">
          <Box
            className={`h-6 w-3/5 animate-pulse rounded-none opacity-70 ${bgColor}`}
          />
          <Box
            className={`h-6 w-4/5 animate-pulse rounded-none opacity-70 ${bgColor}`}
          />
        </Box>
      </Box>
    </SkeletonPlaceholder>
  </Box>
);

SkeletonNoteView.displayName = "SkeletonNoteView";

export default memo(SkeletonNoteView);
